// extracted by mini-css-extract-plugin
export default {"avatar":"Avatar_avatar__qbz0B","avatar_image":"Avatar_avatar_image__tQKiz","avatar_empty":"Avatar_avatar_empty__YAl2R","avatar_empty_name":"Avatar_avatar_empty_name__g6wUg"};